import type { ApiCommonResponse, ApiNgResponse } from "./common";

export type { ApiCommonResponse, ApiNgResponse };

export type MasterType = "com" | "tok";

export type PreviewUserStatus =
  | "add"
  | "update"
  | "delete"
  | "error"
  | "ok";

export type PreviewUserRow = {
  row_no: number;
  status: PreviewUserStatus;
  name: string;
  open_id: string;
};

export type PreviewUserItem = {
  user: PreviewUserRow;
};

export type UserMasterPreviewOkResponse = {
  status: "ok";
  message: string;
  message_detail?: string | null;
  master_type: MasterType;
  latest_master_s3_key: string;
  users: PreviewUserItem[];
  users_delete: PreviewUserItem[];
};

export type UserMasterPreviewResponse =
  | UserMasterPreviewOkResponse
  | ApiNgResponse;

export type UserMasterUploadOkResponse = {
  status: "ok";
  message: string;
  message_detail?: string | null;
  master_type: MasterType;
  uploaded_file_name: string;
};

export type UserMasterUploadResponse =
  | UserMasterUploadOkResponse
  | ApiNgResponse;

export type UserMasterDownloadOk = {
  status: "ok";
  blob: Blob;
  filename: string;
};

export type UserMasterDownloadNg = {
  status: "ng";
  message: string;
};

export type UserMasterDownloadResult =
  | UserMasterDownloadOk
  | UserMasterDownloadNg;

export type PreviewTableRow = PreviewUserRow & { key: string };

export const isPreviewUserItem = (
  item: PreviewUserItem | PreviewUserRow
): item is PreviewUserItem => "user" in item && item.user !== undefined;

export const normalizePreviewItem = (
  item: PreviewUserItem | PreviewUserRow
): PreviewUserRow => (isPreviewUserItem(item) ? item.user : item);
